import { Mic, Volume2 } from 'lucide-react';

export default function Reading({ question, taskState, status, transcript }) {
  const readSentences = taskState?.read || [];
  const activeIndex = readSentences.length;
  const activeLine = question.mediaText[activeIndex];
  
  return (
    <div className="flex flex-col items-center justify-between gap-4 w-full max-w-4xl h-full py-4">
      <h2 className="text-xl md:text-2xl font-semibold text-muted-foreground text-center flex-shrink-0">
        Прочитайте предложение вслух
      </h2>
      
      {/* Прочитанные предложения (сверху, мелко) */}
      <div className="flex flex-col gap-2 w-full items-center flex-shrink-0 overflow-hidden max-h-[80px]">
        {readSentences.map((idx) => (
          <p key={idx} className="text-green-600 text-base line-through opacity-70 text-center">
            {question.mediaText[idx]}
          </p>
        ))}
      </div>
      
      {/* Активное предложение (по центру, крупно) */}
      <div className="flex-grow flex items-center justify-center w-full min-h-[150px] max-h-[50vh]">
        {activeLine && (
          <div className="w-full p-6 md:p-8 bg-secondary border-2 border-accent rounded-3xl shadow-2xl flex items-center justify-center">
            <p className="text-primary text-2xl md:text-4xl text-center font-medium">
              {activeLine}
            </p>
          </div>
        )}
      </div>
      
      {/* Микрофон/Динамик (внизу, фиксированной высоты) */}
      <div className="flex flex-col items-center justify-center gap-4 min-h-[80px] flex-shrink-0">
        {status === 'speaking' && <Volume2 className="size-12 text-accent animate-pulse" />}
        {status === 'listening' && (
          <div className="flex flex-col items-center gap-4">
            <Mic className="size-12 text-red-500 animate-bounce" />
            <div className="px-6 py-2 bg-secondary rounded-full border-2 border-red-500/30 text-center min-h-[40px] flex items-center max-w-xs">
              <span className="text-lg text-primary font-medium">{transcript || "Слушаю..."}</span>
            </div>
          </div>
        )}
      </div>
    </div>
  );
}